<div class="card shadow-sm border-0">
  <div class="card-body">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5 class="mb-0">Step 1 · Fields</h5>
      <span class="badge text-bg-light border">{{ fields.length }} fields</span>
    </div>

    <div *ngIf="!fields.length" class="text-muted small">
      No fields available for this application yet.
    </div>

    <div class="row g-3" [formGroup]="form" *ngIf="fields.length">
      <div
        *ngFor="let field of fields; trackBy: trackByField"
        class="col-12"
        [ngClass]="isTextarea(field) ? 'col-md-12' : 'col-md-6'">

        <label class="form-label">
          {{ field.label || field.fieldKey }}
          <span class="text-danger" *ngIf="field.isRequired">*</span>
        </label>

        <textarea
          *ngIf="isTextarea(field)"
          class="form-control"
          rows="3"
          [formControlName]="field.fieldKey"
          [placeholder]="field.label || field.fieldKey">
        </textarea>

        <select
          *ngIf="isSelect(field)"
          class="form-select"
          [formControlName]="field.fieldKey">

          <option value="">
            Select {{ field.label || field.fieldKey }}
          </option>

          <option
            *ngFor="let option of getSelectOptions(field)"
            [value]="option.value">

            {{ option.label }}
          </option>

        </select>

        <input
          *ngIf="!isTextarea(field) && !isSelect(field)"
          class="form-control"
          [type]="inputType(field)"
          [formControlName]="field.fieldKey"
          [placeholder]="field.label || field.fieldKey"
          [attr.min]="field.fieldType.toLowerCase() === 'date' ? getMinDate(field) : null"
          [attr.max]="field.fieldType.toLowerCase() === 'date' ? getMaxDate(field) : null"
        />

        <div class="small text-danger mt-1"
             *ngIf="form.get(field.fieldKey)?.touched && form.get(field.fieldKey)?.invalid">
          This field is required.
        </div>
      </div>
    </div>
  </div>
</div>